import { Modal } from "antd";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import { Recaptcha } from "./Recaptcha";

function RecaptchaModal({ open, setOpen, onSuccess }) {
  const [recaptchaSiteKey, setRecaptchaSiteKey] = useState("");
  const [recaptchaToken, setRecaptchaToken] = useState("");

  useEffect(() => {
    setRecaptchaSiteKey("6LdrlqspAAAAAG0sSGmfxSgpe3ZGmXybC3aBZNOU");
  }, []);

  useEffect(() => {
    if (open && recaptchaToken?.length) {
      setOpen(false);
      const token = recaptchaToken;
      setRecaptchaToken("");
      onSuccess(token);
    }
  }, [open, recaptchaToken]);

  return (
    <Modal
      width="auto"
      centered
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      maskClosable={false}
    >
      <div className="display-flex-center-h-and-v" style={{ padding: "16px" }}>
        <Recaptcha
          recaptchaToken={recaptchaToken}
          setRecaptchaToken={setRecaptchaToken}
          recaptchaSiteKey={recaptchaSiteKey}
        />
      </div>
    </Modal>
  );
}

RecaptchaModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export { RecaptchaModal };
